<style lang="scss" scoped>
.v-card__text {
  min-height: 100px !important;
}

.results-title-container, .form-title-container {
  .subtitle-2 {
    font-weight: normal;
  }
}

.results-container {
  .centered-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .welcome-container {
    height: 168px;
  }

  .data-container {
    display: flex;
    justify-content: center;

    .circle {
      width: 7.87rem;
      height: 7.87rem;
      border-radius: 50%;
      background-color: #BCE0FD;
      font-size: 4.3rem;
      font-weight: bold;
      color: #007BFF;
    }
  }
}
</style>

<template>
  <v-row>
    <v-col sm="12" md="4">
      <v-card :class="formCardClass">
        <v-card-title class="form-title-container">
          {{ formTitle }}
          <v-spacer />
          <span class="subtitle-2">
            <slot name="form-title-appendix" />
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <slot name="form-content" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card :class="resultsCardClass">
        <v-card-title class="results-title-container">
          {{ resultsTitle }}
          <v-spacer />
          <span class="subtitle-2">
            <slot name="results-title-appendix" />
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="results-container black-text"
          :class="{
            'gray-bg': this.hideResults,
            'pa-0': this.resultsNoPadding,
          }"
        >
          <div v-if="this.hideResults" class="welcome-container centered-container">
            {{ message }}
          </div>
          <div v-else>
            <slot name="results-content" />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formTitle: {
      type: String,
      default: 'Form',
    },
    formCardClass: String,
    resultsTitle: {
      type: String,
      default: 'Results',
    },
    resultsCardClass: String,
    message: {
      type: String,
      default: 'Submit an inquiry.',
    },
    resultsNoPadding: Boolean,
    hideResults: Boolean,
  },
};
</script>
